/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Listen_On_Go_CtaInputs */

const en_features_listen_on_go_cta = /** @type {(inputs: Features_Listen_On_Go_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Give it a try`)
};

const es_features_listen_on_go_cta = /** @type {(inputs: Features_Listen_On_Go_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pruébalo`)
};

/**
* | output |
* | --- |
* | "Give it a try" |
*
* @param {Features_Listen_On_Go_CtaInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const features_listen_on_go_cta = /** @type {((inputs?: Features_Listen_On_Go_CtaInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Listen_On_Go_CtaInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_features_listen_on_go_cta(inputs)
	return en_features_listen_on_go_cta(inputs)
});